module.exports = __webpack_public_path__ + "img/17.6d8272d3.jpg";